import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { ChevronRight } from 'lucide-react';

interface BreadcrumbItem {
  label: string;
  to?: string;
}

interface AdminBreadcrumbProps {
  items: BreadcrumbItem[];
}

export const AdminBreadcrumb = ({ items }: AdminBreadcrumbProps) => {
  const { t } = useTranslation();

  return (
    <nav aria-label={t('admin.breadcrumb')} className="mb-4">
      <ol className="flex flex-wrap items-center gap-1 text-sm text-[var(--color-ink-faint)]">
        {items.map((item, index) => (
          <li key={item.label} className="flex items-center gap-1">
            {index > 0 && <ChevronRight className="h-3.5 w-3.5 shrink-0" />}
            {item.to ? (
              <Link to={item.to} className="transition-colors hover:text-[var(--color-accent)]">
                {item.label}
              </Link>
            ) : (
              <span className="font-medium text-[var(--color-ink)]">{item.label}</span>
            )}
          </li>
        ))}
      </ol>
    </nav>
  );
};
